
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1966"}},[_c('path',{attrs:{"data-name":"Rectangle 2697","fill":"#f9a36c","d":"M2 2h20v20H2z"}}),_c('path',{attrs:{"data-name":"Path 1289","d":"M22 2v20H2V2h20m1-2H1a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1V1a1 1 0 00-1-1z"}}),_c('path',{attrs:{"data-name":"Path 1290","d":"M13.512 20.137a1.9 1.9 0 01-1.663-1.179c-.248-.44-.307-.523-.687-.523A10.548 10.548 0 007.2 19.99a1 1 0 01-1.493-1.1l1.539-6.091-.981.395a1 1 0 11-.748-1.855l2.807-1.131a1 1 0 011.343 1.173l-1.475 5.845a8.043 8.043 0 012.97-.79 2.575 2.575 0 012.429 1.54l.087.152a32.925 32.925 0 003.925-.976 1 1 0 11.576 1.916 27.454 27.454 0 01-4.667 1.069z"}}),_c('path',{attrs:{"data-name":"Path 1291","d":"M19 5.5H5a.5.5 0 010-1h14a.5.5 0 010 1z"}}),_c('path',{attrs:{"data-name":"Path 1292","d":"M19 8.5H5a.5.5 0 010-1h14a.5.5 0 010 1z"}})])])
          )
        }
      }
    